export var RegionType;
(function (RegionType) {
    RegionType["Button"] = "button";
    RegionType["Divider"] = "divider";
    RegionType["Follow"] = "follow";
    RegionType["Html"] = "html";
    RegionType["Footer"] = "footer";
    RegionType["Image"] = "image";
    RegionType["Link"] = "link";
    RegionType["Logo"] = "logo";
    RegionType["Mix"] = "mix";
    RegionType["Music"] = "music";
    RegionType["Rsvp"] = "rsvp";
    RegionType["Subscribe"] = "subscribe";
    RegionType["Text"] = "text";
    RegionType["Video"] = "video";
})(RegionType || (RegionType = {}));
export var SocialFollowButtons;
(function (SocialFollowButtons) {
    SocialFollowButtons["facebook"] = "facebook";
    SocialFollowButtons["instagram"] = "instagram";
    SocialFollowButtons["linkedIn"] = "linkedIn";
    SocialFollowButtons["pinterest"] = "pinterest";
    SocialFollowButtons["soundCloud"] = "soundCloud";
    SocialFollowButtons["twitter"] = "twitter";
    SocialFollowButtons["youtube"] = "youtube";
})(SocialFollowButtons || (SocialFollowButtons = {}));
export var LogoType;
(function (LogoType) {
    LogoType["custom"] = "custom";
    LogoType["siteLogo"] = "siteLogo";
})(LogoType || (LogoType = {}));
//# sourceMappingURL=types.js.map